import { createTheme } from '@material-ui/core/styles';
import getCapitalTheme from '.';

const theme = createTheme(getCapitalTheme as any) as any;

const themeWithOverride = {
  ...theme,
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: 14,
      },
    },
    MuiFormLabel: {
      root: {
        color: theme.palette.text.primary,
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: theme.palette.secondary.main,
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
      outlinedSecondary: {
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTabs: {
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        margin: 0,
        minWidth: 0,
        padding: 0,
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
          padding: theme.spacing(0, 2),
          minWidth: 150,
        },
        '&$selected': {
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          borderTop: `3px solid ${theme.palette.warning.main}`,
          borderLeft: `1px solid ${theme.palette.grey[200]}`,
          borderRight: `1px solid ${theme.palette.grey[200]}`,
          borderBottom: 0,
          fontWeight: 500,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: theme.palette.success[800],
      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiListItem: {
      button: {
        '&:hover': {},
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiFormHelperText: {
      contained: {
        margin: theme.spacing(1, 0),
      },
    },
    MuiCssBaseline: {
      '@global': {
        html: {
          width: '100%',
        },
        body: {
          color: theme.palette.secondary.main,
          width: '100%',
        },
        'input::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        'input::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        'input[type=number]': {
          '-moz-appearance': 'textfield',
        },
        a: {
          color: theme.palette.primary.main,
          textDecoration: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: theme.palette.common.white,
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
      },
      input: {
        paddingTop: 14,
        paddingBottom: 14,
      },
    },
    MuiInputBase: {
      input: {
        fontSize: 14,
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
      },
    },
    MuiPaper: {
      // use the same shadow effect for all elevations
      ...Array(25)
        .fill('0 1px 8px 0 rgba(17, 18, 18, 0.1) !important')
        .map((value) => {
          return { elevation1: value };
        })
        .reduce((o: any, item: any, index: number) => {
          return index === 0 ? null : { ...o, [`elevation${index}`]: { boxShadow: item.elevation1 } };
        }),
      root: {
        color: theme.palette.secondary.main,
      },
    },
    MuiTableCell: {
      root: {
        fontSize: '14px',
      },
    },
    MuiAccordionSummary: {},
    MuiToggleButton: {
      root: {
        '&$selected': {
          backgroundColor: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.common.white,
          },
        },
      },
    },
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    ...theme.mixins,
    toolbar: {
      minHeight: theme.spacing(6),
    },
  },
};

export default themeWithOverride;
